<template>
  <div class="header-wrapper">
    <div class="header-row">
      <div class="company-info">
        <h2 v-if="!isLoading">{{ title }}</h2>
        <free-style-shimmer
            :is-loading="isLoading"
            height="20px"
            width="250px"
            border-radius="50px"
            color="#dedede"
        />

        <div class="company-status" v-if="!isLoading">
          <img src="@/assets/images/active.svg" v-if="status" />
          <img src="@/assets/images/failed.svg" v-else />
          <span v-if="status">{{ $t('active') }}</span>
          <span v-else>{{ $t('inactive') }}</span>
        </div>

        <free-style-shimmer
            :is-loading="isLoading"
            height="10px"
            width="100px"
            border-radius="50px"
            color="#dedede"
        />
      </div>

      <div class="action-row">
        <button class="action-button" @click="onDelete">
          <img src="@/assets/images/trash.svg"/>
        </button>
        <button class="action-button" @click="onEdit">
          <img src="@/assets/images/editPen.svg" />
        </button>
        <button class="action-button" @click="showLogModal">
          <img src="@/assets/images/logIconNewGrey.svg" />
        </button>
        <LogModal
            :visible="isLogModalVisible"
            :on-hide="hideLogModal"
            :data="logData"
        />
        <div class="invite-holder">
          <div class="invite-code" :data-tooltip="$t('invite_with_this_code')" >
            <free-style-shimmer
                :is-loading="isCodeLoading"
                height="20px"
                width="80px"
                border-radius="50px"
                color="#dedede"
            />
            <span v-if="!isCodeLoading">{{code}}</span>
            <img v-if="!isCodeLoading" src="@/assets/images/copyOutline.svg" @click="copyCode" class="invite-code-icon">
            <img v-if="!isCodeLoading" @click="changeCode" class="refresh-icon" src="@/assets/images/refresh.svg">
          </div>
        </div>
      </div>
    </div>
    <div class="company-stats">
      <div class="stat-wrapper">
        <img src="@/assets/images/usersOutline.svg" />
        <span v-if="!isLoading">
          <span class="stat-number">{{userCount}}</span> {{ $t('users_added') }}
        </span>


        <free-style-shimmer
            :is-loading="isLoading"
            height="8px"
            width="80px"
            border-radius="50px"
            color="#dedede"
        />
      </div>


      <div class="stat-wrapper">
        <img src="@/assets/images/verified.svg" />
        <span v-if="!isLoading">
          <span class="stat-number">{{programCount}}</span> {{ $t('programs_added') }}
        </span>

        <free-style-shimmer
            :is-loading="isLoading"
            height="8px"
            width="80px"
            border-radius="50px"
            color="#dedede"
        />
      </div>

      <div class="stat-wrapper">
        <img src="@/assets/images/datepicker.svg" />
        <span v-if="!isLoading">
         {{$t('created_at')}} {{ formatDate(createdAt) }}
        </span>

        <free-style-shimmer
            :is-loading="isLoading"
            height="8px"
            width="80px"
            border-radius="50px"
            color="#dedede"
        />
      </div>
    </div>

    <img :src="photo" class="company-image" v-if="!isLoading && photo !== null"/>
    <free-style-shimmer
        class="company-image"
        :is-loading="isLoading"
        height="120px"
        width="120px"
        border-radius="50%"
        color="#dedede"
    />
  </div>
</template>

<script>


import LogModal from "@/components/modals/LogModal.vue";
import companyService from "@/service/companyService";

export default {
  components: {LogModal},
  props: {
    isLoading: {
      type: Boolean,
      default: true
    },
    onEdit: {
      type: Function,
      default: () => {}
    },
    onDelete: {
      type: Function,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    },
    inviteCode: {
      type: String,
      default: ''
    },
    companyId: {
      type: String,
      default: ''
    },
    status: {
      type: Boolean,
      default: true
    },
    userCount: {
      type: Number,
      default: 0
    },
    programCount: {
      type: Number,
      default: 0
    },
    createdAt: {
      type: String,
      default: ''
    },
    photo: {
      type: String,
      default: ''
    },

  },
  data() {
    return {
      logData:[],
      isLogModalVisible:false,
      code:null,
      isCodeLoading:false
    }
  },
  mounted() {
    this.getLogs(this.$i18n.locale);
    this.code = this.inviteCode;
  },
  watch:{
    inviteCode: {
      handler(newValue) {
        this.code = newValue;
      },
      immediate: true
    },
    isLoading: {
      handler(newValue) {
        this.isCodeLoading = newValue;
      },
      immediate: true
    }
  },
  methods: {
    getLogs(lang){
      const routeParams = this.$route.params;
      if(routeParams.id!=='new'){
        companyService.getDetailLogs(lang,routeParams.id).then((res) => {
          this.logData=res.data.data.data;
        })
      }
    },
    showLogModal(){
      this.isLogModalVisible=true;
    },
    hideLogModal(){
      this.isLogModalVisible=false;
    },
    formatDate(dateStr) {
      try {
        const date = new Date(dateStr);
        const options = {year: 'numeric', month: 'short', day: 'numeric'};
        return date.toLocaleDateString("en", options);
      } catch (e) {
        return '-';
      }
    },

    copyCode() {
      if(this.inviteCode) {
        navigator.clipboard
            .writeText(this.code)
            .then(() => {
              this.$snackbar.add({
                text: this.$t("create_invite_code_success"),
                type: "success"
              });
            })
      }
      if(this.code === null){
        this.$snackbar.add({
          text: this.$t("create_invite_code_error"),
          type:"error"
        });
      }
    },
    changeCode(){
      this.isCodeLoading = true;
      companyService.changeInviteCode(this.companyId).then(response => {
        this.code = response.data.data.inviteCode;
      }).finally(()=>this.isCodeLoading = false);
    },

  },
}
</script>

<style scoped>
.header-wrapper {
  position: relative;
  background-color: #F9FAFB;
  background-image: url("@/assets/images/companyHeader.svg");
  background-size: cover;
  padding: 40px;
  margin-bottom: 60px;
}
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
h2 {
  font-family: euclid_semi_bold, sans-serif;
  font-size: 24px;
  color: #101828;
  margin: 0;
  padding: 0;
}
.company-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px
}
.company-status {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
}
.company-status span {
  font-family: euclid_medium, sans-serif;
  font-size: 12px;
  color: #344054;
}
.action-row {
  display: flex;
  flex-direction: row;
  gap: 5px;
}
.action-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: 1px solid #98A2B3;
  background-color: #FFFFFF;
  border-radius: 12px;
  padding: 7px 10px;
  cursor: pointer;
}
.action-button img {
  height: 16px;
  width: 16px;
}
.action-button:hover {
  background-color: #f5f5f5;
}
.company-stats {
  margin-top: 30px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 12px;
}

.stat-wrapper {
  display: flex;
  align-items: center;
  gap: 5px;
}

.stat-wrapper img {
  height: 16px;
  width: 16px;
}

.stat-wrapper span {
  font-size: 12px;
}

.stat-number {
  font-family: euclid_medium, sans-serif;
  font-size: 16px;
  color: #101828;
}

.company-image {
  height: 120px;
  width: 120px;
  border-radius: 50%;
  position: absolute;
  bottom: -60px;
  left: 40px;
}

.invite-code-icon{
  align-self: center;
  height: 15px;
  justify-content: center;
  padding-left: 5px;
}

.refresh-icon{
  height: 15px;
  padding-left: 5px;
}
.invite-code{
  border: 1px solid #98A2B3;
  background-color: #FFFFFF;
  border-radius: 12px;
  padding: 5.5px 10px;
  color: #000000;
  font-size: 13px;
  cursor: pointer;
  position: relative;
}
.invite-code::after {
  content: attr(data-tooltip);
  position: absolute;
  top: -35px;
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
  padding: 5px 10px;
  border-radius: 4px;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  z-index: 10;
  white-space: normal;
  width: 150px;
  font-size: 10px;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background-color: #040C2D;

}
.invite-code:hover::after {
  opacity: 1;
  visibility: visible;
}
.invite-holder{
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  width: 110px;
}
</style>
